import { motion } from 'framer-motion';
import { IMessage } from '../../../types/common';
import { ChatMessageSpan } from './chat.styled';
import { memo } from 'react';
import DOMPurify from 'dompurify';
import TypingAnimation from './animation';

interface ChatMessageProps {
  message: IMessage;
  right: boolean;
  onClick?: () => void;
  index: number;
  lastChangedIndex: number | null;
}

function ChatMessage({ index, lastChangedIndex, onClick, message, right }: ChatMessageProps) {
  return (
    <motion.div
      layout
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 0.7 }}
      exit={{
        opacity: 0,
        scale: 0.7,
      }}
      transition={{
        opacity: { duration: 0.2 },
        layout: {
          type: 'spring',
          bounce: 0.4,
          duration: lastChangedIndex ? index * 0.15 + 0.85 : 1,
        },
      }}
      style={{ originX: right ? 1 : 0 }}
      className={`flex flex-col p-1 ${right ? 'items-end' : 'items-start'}`}
      tabIndex={-1}>
      <ChatMessageSpan tabIndex={-1} onClick={onClick} right={Boolean(right)}>
        {right && typeof message.text === 'string' ? (
          <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.text) }} />
        ) : typeof message.text === 'string' ? (
          <TypingAnimation text={message.text} />
        ) : (
          message.text
        )}
      </ChatMessageSpan>
    </motion.div>
  );
}

export default memo(ChatMessage);
